import React, { useContext } from "react";
import AddItemForm from "./AddItemForm";
import BulkAddForm from "./BulkAddForm";
import Card from "../UI/Card";
import parse from "html-react-parser";
import AppContext from "../../store/app-context";

import styles from "./QuickAdd.module.css";

const QuickAdd = (props) => {
  const appCtx = useContext(AppContext);

  let label_quickAdd = 'Add Items';
  let label_itemOrFile = 'Add item or upload file.';
  let label_primeHomePage = 'PrimePCR Home Page';
  let label_primeCannotAddErrMsg = 'Cannot be added directly to the cart. Please search for the product using the gene name';

  if(appCtx && appCtx.bioradResources){
    label_quickAdd = appCtx.bioradResources.Quick_Add ? appCtx.bioradResources.Quick_Add : 'Add Items';
    label_itemOrFile = appCtx.bioradResources.Add_Item_Or_Upload_File ? appCtx.bioradResources.Add_Item_Or_Upload_File : 'Add item or upload file.';
    label_primeHomePage = appCtx.bioradResources.PrimePCR_Home_Page ? appCtx.bioradResources.PrimePCR_Home_Page : 'PrimePCR Home Page';
    label_primeCannotAddErrMsg = appCtx.bioradResources.PrimePCR_Cannot_Add ? appCtx.bioradResources.PrimePCR_Cannot_Add : 'Cannot be added directly to the cart. Please search for the product using the gene name';
  }

  const primeHomePageURL = appCtx.envProp.appServer
  + appCtx.lang.toLowerCase() +
  "-" +
  appCtx.country.toLowerCase() +
  '/product/primepcr-pcr-primers-assays-arrays?ID=M0HROA15';

  let errorMessage = props.errorMsg && props.errorMsg.length > 0 ? props.errorMsg : null;
  if(errorMessage && errorMessage.indexOf('::') !== -1){
    const msgArray = errorMessage.split('::');
    if(msgArray && msgArray.length>1){
      if(msgArray[1] === 'oligo_UploadAddSku_Invalid'){
        errorMessage = msgArray[0] + ': ' + label_primeCannotAddErrMsg;
      }
    }
  }

  return (
    <Card className={styles.input}>
      <details open className={styles.accordion}>
        <summary>
          <div>
            <h2 class="tier4">{label_quickAdd}</h2>
            {label_itemOrFile}
          </div>
        </summary>
        <Card className={styles.testing}>
          <AddItemForm onAddItem={props.onAddItem} quote={props.quote} />
          <BulkAddForm onAddItem={props.onAddItem} quote={props.quote} />
          {props.errorMsg &&
            props.errorMsg.indexOf("oligo_UploadAddSku_Invalid") === -1 &&
            errorMessage &&
            errorMessage.length > 0 && (
              <p className={styles.errormsg}>{parse(errorMessage)}</p>
            )}
          {props.errorMsg &&
            props.errorMsg.indexOf("oligo_UploadAddSku_Invalid") !== -1 &&
            errorMessage &&
            errorMessage.length > 0 && (
              <p className={styles.errormsg}>{parse(errorMessage)}&nbsp;<a href={primeHomePageURL}>{label_primeHomePage}</a></p>
            )}
        </Card>
      </details>
    </Card>
  );
};

export default QuickAdd;

